import React from 'react'
import { Button, Text, View } from 'oio-react'
import PropTypes from 'prop-types'

const Forbidden = ({ message }) => {
   return (
      <View
         width="100%"
         height="100vh"
         display="flex"
         justifyContent="center"
         alignItems="center"
         backgroundColor="#fff"
         textAlign="center">
         <View
            display="flex"
            flexFlow="column"
            justifyContent="center"
            alignItems="center"
            padding="30px"
            maxWidth="100%[a-b] 450px[c-f]">
            <View width="100%" height="20px" />
            <Text size="3" color="#444" lineHeight="150%" weight="medium">
               Sorry! The page you are looking for
               <br />
                is private.
            </Text>
            <View width="100%" height="20px" />
            <Text size="2" color="#666" lineHeight="150%">
               {message}
            </Text>
            <View width="100%" height="20px" />
            <a href="/">
               <Button
                  name="Return Home"
                  color="#444"
                  size="sm"
                  rounded
               />
            </a>
         </View>
      </View>
   )
}

Forbidden.propTypes = {
   message: PropTypes.string.isRequired
}

export default Forbidden
